export default __webpack_public_path__ + "static/media/Formular.6d3c9849.ttf";